import React, { useEffect, useState } from "react";

import MailDeliverySetting from "./MailDeliverySetting";
import { MailPrefsWithoutNecessary } from "../../../../common/classes/SonicUserMeta";

import { useAppSelector, useAppDispatch } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import { updateOwnMailPrefs } from "../../../../redux/reducers/user";

import { RequestState } from "../../../../utils/RequestState";

type Props = {
  mailPreferences?: MailPrefsWithoutNecessary;
  handleClose: () => void;
};

const MailDeliverySettingContainer: React.FC<Props> = ({
  mailPreferences,
  handleClose,
}) => {
  const dispatch = useAppDispatch();
  const auth_token = useAppSelector(getAuthToken);

  const [isChanged, setIsChanged] = useState<boolean>(false);
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );
  const [prefs, setPrefs] = useState<MailPrefsWithoutNecessary>({
    topics: false,
    events: false,
    portfolios: false,
    projects: false,
    teams: false,
    facilities: false,
    offers: false,
    chat: false,
  });

  const handlePrefs = (value: MailPrefsWithoutNecessary) => {
    setRequestState(RequestState.Pending);
    if (!isChanged) setIsChanged(true);
    setPrefs(value);
  };

  const handleSubmit = () => {
    if (auth_token) {
      setRequestState(RequestState.Doing);
      dispatch(
        updateOwnMailPrefs({ auth_token: auth_token, update: prefs })
      ).finally(() => {
        setIsChanged(false);
        setRequestState(RequestState.Success);
      });
    }
  };

  useEffect(() => {
    if (mailPreferences) {
      setPrefs(mailPreferences);
    }
  }, []);

  return (
    <MailDeliverySetting
      mailPreferences={prefs}
      isChanged={isChanged}
      handlePrefs={handlePrefs}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      requestState={requestState}
    />
  );
};

export default MailDeliverySettingContainer;
